import { Box, Paper, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import Base from "../../../Base/views/Base"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import MyTaxReport from "../TaxDeclaration/MyTaxReport";
import MyPaySlipReport from "./MyPaySlipReport";

const EmployeeReportLandingPage = () => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Base>
            <Box sx={{ maxHeight: "87vh", overflowY: 'auto' }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    sx={{mb: 1}}
                    variant="scrollable"
                    orientation="horizontal"
                    allowScrollButtonsMobile={true}
                    >
                    <Tab label="My Tax Report" {...a11yProps(0)} />
                    <Tab label="My PaySlip" {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <MyTaxReport />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <MyPaySlipReport />
                </TabPanel>
            </Box>
        </Base>
    )
}

export default EmployeeReportLandingPage;
